// 사용량 막대 한 줄(사진 용량·알림톡) — 비율·양·막대 · 80% 는 주의 색, 100% 넘으면 위험 색 · 막지 않는다.

import type { ReactNode } from "react";

import { formatRate } from "@buildpy/core/lib/format";
import { type UsageMeter } from "@buildpy/core/modules/plan/usage-limit";
import { cn } from "@/lib/utils";
import { barPercentOf } from "./usage-meter-state";

const BAR_CLASS = { ok: "fill-primary", near: "fill-warning", over: "fill-destructive" } as const;

interface Props {
  label: ReactNode;
  meter: UsageMeter;
  amount: string;
  note?: ReactNode;
  badge?: ReactNode;
  testId: string;
}

const UsageMeterRow = ({ label, meter, amount, note, badge, testId }: Props) => (
  <div className="flex flex-col gap-1.5" data-level={meter.level} data-testid={testId}>
    <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1">
      <span className="flex items-center gap-2 text-sm font-semibold">
        {label}
        {badge}
      </span>
      <span className={cn("text-sm tabular-nums", meter.level === "over" ? "font-semibold text-destructive" : meter.level === "near" ? "font-semibold text-warning" : "text-secondary-foreground")}>
        {amount}
        {meter.rate !== null && <span className="ml-2 text-muted-foreground">{formatRate(Math.round(meter.rate * 100) / 100)}</span>}
      </span>
    </div>
    {/* 막대는 svg 폭 속성으로 — 인라인 style 을 늘리지 않는다(shadcn-warn-cap). */}
    <div aria-hidden className="h-2 w-full overflow-hidden rounded-full bg-muted">
      <svg className="block h-2 w-full" preserveAspectRatio="none" viewBox="0 0 100 2">
        <rect className={BAR_CLASS[meter.level]} height="2" width={barPercentOf(meter)} />
      </svg>
    </div>
    {note && <p className="text-xs text-muted-foreground">{note}</p>}
  </div>
);

export default UsageMeterRow;
